export enum TicketType {
    Normal,
    Automatic,
    Issue,
    Maintenance,
    FromReturn
}
